import { hasArrayElements } from "@/apiUtils/commonUtils";
import NoImageSrc from "@/assets/images/no_image.svg";
import CldImage from "@/components/ui/cldImg/CldImage";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { ProductInfoTabProps } from "../../types";
import { combineAltTextWithImageInfo } from "@/utils/product.utils";
import { useParams } from "next/navigation";
import { getLangFromLocale } from "@/utils/common";

const ProductInfo = ({ data, label, id, altText }: ProductInfoTabProps & { id?: string }) => {
  const { locale } = useParams();
  const lang = getLangFromLocale(locale as string);

  return (
    <div
      id={id}
      className="flex h-full flex-col-reverse items-center justify-center max-md:py-5 lg:flex-row"
    >
      <div className="flex flex-1 flex-col items-center gap-6 py-5 font-semibold max-sm:ms-5">
        <div>
          <h2 className="mb-[2.938rem] hidden md:block md:text-xl">{label}</h2>
          <div className="flex flex-col gap-[1.125rem] max-md:text-sm">
            {data?.["productInfo"]?.map(
              (item, idx) =>
                item.label != undefined &&
                item.value != undefined &&
                String(item.value ?? "").toLowerCase() !== "no" && item.value !== "كلا" && item.value !== '-' && (
                  <div key={idx} className="flex items-start gap-0 lg:gap-10">
                    <span className="w-[10rem] flex-shrink-0 font-bold capitalize">{item.label}</span>
                    <span className="flex flex-1 items-start gap-2">
                      <span className="mt-[0.4rem] h-1 w-1 flex-shrink-0 rounded-full bg-black"></span>
                      <span className="flex-1 font-medium">{item.value}</span>
                    </span>
                  </div>
                ),
            )}
          </div>
        </div>
      </div>
      <div className="flex h-[9.75rem] w-full flex-1 items-center justify-center md:h-[30.625rem] md:w-[62.75rem]">
        <CldImage
          src={
            hasArrayElements(data.images) && data.images[0]
              ? getCloudinaryURL(data.images[0]?.url)
              : NoImageSrc.src
          }
          alt={altText}
          width={708}
          height={608}
          className="invert-[2%]"
        />
      </div>
    </div>
  );
};

export default ProductInfo;
